import { shape, string } from 'prop-types'

import PriceListES_v1 from './PriceListES_v1'

export default {
  id: string,
  price: shape(PriceListES_v1),
  thumbnailURL: string,
  name: string,
}
